var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg5Cinza(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 50,
    rx: 4,
    fill: "#ACACAC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 9.75,
    width: 63.25,
    height: 30.25,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0833 27C15.7906 27 16.4689 27.281 16.969 27.781C17.469 28.2811 17.75 28.9594 17.75 29.6667C17.75 30.3739 17.469 31.0522 16.969 31.5523C16.4689 32.0524 15.7906 32.3333 15.0833 32.3333C14.3761 32.3333 13.6978 32.0524 13.1977 31.5523C12.6976 31.0522 12.4167 30.3739 12.4167 29.6667C12.4167 28.9594 12.6976 28.2811 13.1977 27.781C13.6978 27.281 14.3761 27 15.0833 27M15.0833 33.6667C18.03 33.6667 20.4167 34.86 20.4167 36.3333V36.3333C20.4167 37.0697 19.8197 37.6667 19.0833 37.6667H11.0833C10.347 37.6667 9.75 37.0697 9.75 36.3333V36.3333C9.75 34.86 12.1367 33.6667 15.0833 33.6667Z",
    fill: "#ACACAC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg5Cinza);
export default __webpack_public_path__ + "static/media/img5cinza.b4b0beac5e8a985853d2c7f9c08c2e65.svg";
export { ForwardRef as ReactComponent };